import Axios from 'axios'
import store from './index'
import { createBasicAuthConfig } from '../util/api'

const defaultState = () => ({
  rawCollections: [],
  rawSharedToMeCollections:[],
  rawPapers: [],
  selectedCollectionId: null,
  isFetchingCollection: false,
  isFetchingPapers: false
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setRawCollections(state, payload) {
      state.rawCollections = payload
    },
    setRawSharedToMeCollections(state, payload){
      state.rawSharedToMeCollections = payload
    },
    setRawPapers(state, payload) {
      state.rawPapers = payload
    },
    setSelectedCollectionId(state, payload) {
      state.selectedCollectionId = payload
    },
    reset(state) {
      Object.assign(state, defaultState())
    },
    setIsFetchingCollection(state, payload){
      state.isFetchingCollection = payload
    },
    setIsFetchingPapers(state, payload){
      state.isFetchingPapers = payload
    }
  },
  getters: {
    selectedCollectionSharingUsers: state => {
      const search = state.rawCollections.concat(state.rawSharedToMeCollections)
        .filter(x => x.id === state.selectedCollectionId)
      if (search.length > 0) {
        return search[0].sharingUsers
      } else {
        return []
      }
    },
    selectedCollectionName: state => {
      const search = state.rawCollections.concat(state.rawSharedToMeCollections)
        .filter(x => x.id === state.selectedCollectionId)
      if (search.length > 0) {
        return search[0].name
      } else {
        return null
      }
    }
  },
  actions: {
    async fetchCollections({ commit }) {
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API

      const url = SERVER_ADDRESS + API.GET_COLLECTIONS
      const authorizationBasic = window.btoa(store.state.authentication.token + ":")
      const config = {
        'headers': {
          'Authorization': 'Basic ' + authorizationBasic,
        }
      }
      commit('setIsFetchingCollection', true)
      await Axios.get(
        url, config
      ).then((resp) => {
        commit('setRawCollections', resp.data.collections)
        commit('setRawSharedToMeCollections', resp.data.sharedToMeCollections)
      })
      commit('setIsFetchingCollection',false)
    },

    async fetchCollectionPapers({ commit }, { collectionId }) {
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API

      commit('setSelectedCollectionId', collectionId)
      commit('setIsFetchingPapers', true)
      const url = SERVER_ADDRESS + API.GET_COLLECTION_PAPERS + collectionId
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      await Axios.get(
        url, config
      ).then((resp) => {
        commit('setRawPapers', resp.data.papers)
      })
      commit('setIsFetchingPapers', false)
    }
  }
}